import { alpha, createTheme } from "@mui/material/styles";

export const appTheme = createTheme({
    palette: {
        primary: {
            main: "#0f766e",
            dark: "#115e59",
            light: "#14b8a6",
        },
        secondary: {
            main: "#c2410c",
        },
        background: {
            default: "#f3f7fb",
            paper: "#ffffff",
        },
        text: {
            primary: "#102a43",
            secondary: "#52606d",
        },
        divider: "#d8e1eb",
    },
    shape: {
        borderRadius: 22,
    },
    typography: {
        fontFamily: '"Manrope", "Segoe UI", sans-serif',
        h2: {
            fontSize: "clamp(2.25rem, 4vw, 3.75rem)",
            fontWeight: 800,
            letterSpacing: "-0.04em",
            lineHeight: 1,
        },
        h3: {
            fontSize: "clamp(1.6rem, 2vw, 2.2rem)",
            fontWeight: 800,
            letterSpacing: "-0.03em",
        },
        h4: {
            fontSize: "clamp(1.3rem, 1.4vw, 1.8rem)",
            fontWeight: 800,
            letterSpacing: "-0.03em",
        },
        h5: {
            fontSize: "1.1rem",
            fontWeight: 800,
        },
        overline: {
            fontWeight: 800,
            letterSpacing: "0.16em",
        },
        button: {
            textTransform: "none",
            fontWeight: 700,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    margin: 0,
                    minHeight: "100dvh",
                    overflowX: "clip",
                    background:
                        "radial-gradient(circle at top left, rgba(59, 130, 246, 0.1), transparent 32%), radial-gradient(circle at top right, rgba(249, 115, 22, 0.08), transparent 26%), #f3f7fb",
                },
                "#root": {
                    minHeight: "100dvh",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                },
            },
        },
        MuiTabs: {
            defaultProps: {
                variant: "scrollable",
                scrollButtons: "auto",
                allowScrollButtonsMobile: true,
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 44,
                    minWidth: "auto",
                    padding: "10px 14px",
                    textTransform: "none",
                    fontWeight: 700,
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    WebkitOverflowScrolling: "touch",
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    "@media (pointer: coarse)": {
                        padding: 10,
                    },
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                fullScreen: false,
            },
            styleOverrides: {
                paper: {
                    margin: 12,
                    width: "calc(100% - 24px)",
                    maxHeight: "calc(100dvh - 24px)",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    boxShadow: "0 20px 45px rgba(16, 42, 67, 0.08)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    paddingInline: 18,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 18,
                        backgroundColor: alpha("#ffffff", 0.9),
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 800,
                    color: "#334e68",
                    backgroundColor: alpha("#0f766e", 0.04),
                },
                root: {
                    borderColor: "#e5edf4",
                },
            },
        },
    },
});
